import WelcomeLayout from "components/templates/welcome";

export default function Welcome() {
	return <WelcomeLayout />;
}
